import { render, staticRenderFns } from "./ModalCostumers.vue?vue&type=template&id=a44d5136&scoped=true"
import script from "./ModalCostumers.vue?vue&type=script&lang=js"
export * from "./ModalCostumers.vue?vue&type=script&lang=js"
import style0 from "./ModalCostumers.vue?vue&type=style&index=0&id=a44d5136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44d5136",
  null
  
)

export default component.exports